/**
 * @flow
 * @relayHash c4ae2157ad3979482d0212229e49b6a3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type filterListQueryVariables = {|
  similarity_search: boolean,
  similarity_seed_id: string,
|};
export type filterListQueryResponse = {|
  +viewer: ?{|
    +node?: ?{|
      +title?: ?string,
      +artist?: ?{|
        +name: ?string,
      |},
    |},
  |},
|};
*/


/*
query filterListQuery(
  $similarity_search: Boolean!
  $similarity_seed_id: ID!
) {
  viewer {
    node(id: $similarity_seed_id) @include(if: $similarity_search) {
      __typename
      ... on TrackSearchResult {
        title
        artist {
          name
          id
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "similarity_search",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "similarity_seed_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "similarity_seed_id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "filterListQuery",
  "id": null,
  "text": "query filterListQuery(\n  $similarity_search: Boolean!\n  $similarity_seed_id: ID!\n) {\n  viewer {\n    node(id: $similarity_seed_id) @include(if: $similarity_search) {\n      __typename\n      ... on TrackSearchResult {\n        title\n        artist {\n          name\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "filterListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "similarity_search",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": v1,
                "concreteType": null,
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "type": "TrackSearchResult",
                    "selections": [
                      v2,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "artist",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Artist",
                        "plural": false,
                        "selections": [
                          v3
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "filterListQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v4,
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "similarity_search",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": v1,
                "concreteType": null,
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  {
                    "kind": "InlineFragment",
                    "type": "TrackSearchResult",
                    "selections": [
                      v2,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "artist",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Artist",
                        "plural": false,
                        "selections": [
                          v3,
                          v4
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'd804b091397711a17589481ff54e1b7d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/filterListQuery.graphql.js